// ABOUTME: Scroll-reveal léger pour les sections Chillow (anti-AI-slop motion)
// ABOUTME: Révèle en fondu/montée les éléments below-the-fold via IntersectionObserver
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('ch-js');

  var SEL = '.ch-benefit,.ch-review,.ch-usages__card,.ch-offers__card,.ch-pdp-row,.ch-compare__col,.ch-mission__inner,.ch-reassurance__item,.ch-adv__r';

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    var els = document.querySelectorAll(SEL), i = 0, d = 0, prevTop = -1;
    for (i = 0; i < els.length; i++) {
      var el = els[i], r = el.getBoundingClientRect();
      // ne révéler que ce qui est sous la ligne de flottaison (pas d'above-fold caché)
      if (r.top > vh * 0.82) {
        // cascade légère pour les éléments d'une même rangée
        d = Math.abs(r.top - prevTop) < 8 ? d + 70 : 0;
        prevTop = r.top;
        el.style.transitionDelay = (d) + 'ms';
        el.classList.add('ch-reveal');
        io.observe(el);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Pages advertorial : débloque tout lock de scroll résiduel + force l'autoplay des vidéos
  function advFixes() {
    if (!document.querySelector('.ch-adv')) return;
    function unlock() {
      [document.documentElement, document.body].forEach(function (el) {
        if (!el) return;
        if (getComputedStyle(el).overflowY === 'hidden') el.style.overflow = 'visible';
        if (el.style.height && el.style.height !== 'auto') el.style.height = 'auto';
      });
      var pw = document.querySelector('.page-wrapper, .template-page');
      if (pw) { pw.style.overflow = 'visible'; pw.style.height = 'auto'; }
    }
    function playVideos() {
      document.querySelectorAll('video[autoplay], .ch-adv video').forEach(function (v) {
        v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    }
    unlock(); playVideos();
    setTimeout(function () { unlock(); playVideos(); }, 700);
    setTimeout(function () { unlock(); playVideos(); }, 1800);
    window.addEventListener('scroll', playVideos, { passive: true, once: true });
    // Galerie : clic sur une vignette -> change la grande image
    var thumbs = document.querySelectorAll('.ch-adv__gallery img');
    if (thumbs.length) {
      thumbs[0].classList.add('is-active');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var hero = document.querySelector('.ch-adv__buy-hero');
          if (hero) hero.src = t.src;
          document.querySelectorAll('.ch-adv__gallery img.is-active').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', advFixes);
  else advFixes();
})();
